import config from './config';
import service from './axiosUtils';
import upload from './upload'
import requestStatus from './requestStatus';

const _config = config;

const install = (Vue) => {
    // eventBus
    Vue.prototype.$bus = new Vue();
    Vue.prototype.$http = service;
    Vue.prototype.$upload = upload;
    Vue.prototype.config = config;
    Vue.prototype.$requestStatus = requestStatus;

};
export default install;



// WEBPACK FOOTER //
// ./src/lib/requestConf/common.js